<template>
    <Breadcrumbs main="Apps" title="Project Create" />
    <div class="container-fluid">
        <div class="row">
            <newProject />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref, defineAsyncComponent } from 'vue'

const newProject = defineAsyncComponent(() => import("@/components/theme/project/createproject/newProject.vue"))
</script>